<template>
<div class="regular-header">

  <headerGrid>
    <div class="font-size-custom-max-48"><h1>Welkom</h1></div>
    <p>Wij willen je vragen de website in een modernere browser te kijken. De website heeft super gave animaties en deze browser kan dat helaas niet aan.</p>
    <a href="https://www.behance.net/foldedpaper">Is dat nu niet mogelijk? Klik dan hier voor onze Behance.</a>
    <a href="tel:0634026022">06-34026022</a>
    <a href="mailto:hello@foldedpaper.nl">hello(at)foldedpaper.nl</a>
  </headerGrid>
<footerComponent></footerComponent>

</div>
</template>

<script>

import headerGrid from '@/components/generalLayout/headerGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'noIE',

  components:{
    headerGrid,
    footerComponent,
  },

}

</script>

<style lang="scss">

.navbar{
  display: none !important;
  background: red;
}
</style>
